module.exports = __webpack_public_path__ + "static/media/ABNB_Report_IPOIntelligence_a.e6e36408.png";